import { Cross2Icon } from '@radix-ui/react-icons'
import type { HTMLAttributes } from 'react'

type Props = HTMLAttributes<HTMLDivElement> & {
  theme?: 'black' | 'gray'
}

export function CloseButton({ theme = 'gray', style, ...divProps }: Props) {
  return (
    <div
      style={{
        borderRadius: '100px',
        fontSize: '16px',
        width: '1.5em',
        height: '1.5em',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        backgroundColor: theme === 'gray' ? '#E4E4E4' : '#1B1C1B',
        ...style,
      }}
      {...divProps}
    >
      <Cross2Icon
        style={{
          width: '1em',
          height: '1em',
          color: theme === 'gray' ? '#AAABAA' : '#FFFFFF',
        }}
      />
    </div>
  )
}
